import { normalizeAdminAuditResponse } from "../utils/adminAuditDisplay";

const hasKeys = (value, keys) => value !== null && typeof value === "object" && !Array.isArray(value) &&
	[Object.prototype, null].includes(Object.getPrototypeOf(value)) && Object.keys(value).length === keys.length &&
	keys.every((key) => Object.prototype.hasOwnProperty.call(value, key));
const filterKeys = ["restaurantId", "actorUid", "action"];
const validCursor = (value) => value === null ||
	(typeof value === "string" && value.length > 0 && value.length <= 4096 && /^[A-Za-z0-9_-]+$/.test(value));
const validLegacyFilters = (filters) => hasKeys(filters, filterKeys) && filterKeys.every((key) => {
	const value = filters[key];
	const pattern = key === "action" ? /^[A-Za-z0-9_.-]+$/ : /^[A-Za-z0-9_.:@-]+$/;
	return value === null || (typeof value === "string" && value === value.trim() &&
		value.length <= (key === "action" ? 120 : 128) && pattern.test(value));
});

export function readAdminAuditPage(data, { projectId, requestingAdminUid, filters, cursors }) {
	// Keep the existing display allowlist as the only path from records to the UI.
	const logs = normalizeAdminAuditResponse(data);
	// Production's existing bounded reader does not promise history completeness or paging metadata.
	if (hasKeys(data, ["logs"]) && projectId === "scervmvp" && Array.isArray(cursors) &&
		cursors.length === 1 && cursors[0] === null && validLegacyFilters(filters)) {
		if (logs.some((log) => (filters.restaurantId !== null && log.facts.payload.restaurantId !== filters.restaurantId) ||
			(filters.actorUid !== null && log.actorUid !== filters.actorUid) ||
			(filters.action !== null && log.action !== filters.action))) throw new Error("Unconfirmed audit filters");
		return { logs, nextCursor: null, limitedHistory: true };
	}
	if (!hasKeys(data, ["schemaVersion", "projectId", "actorUid", "filters", "logs", "nextCursor"]) ||
		data.schemaVersion !== 1 || data.projectId !== projectId || data.actorUid !== requestingAdminUid ||
		!hasKeys(data.filters, filterKeys) || filterKeys.some((key) =>
			(data.filters[key] !== null && typeof data.filters[key] !== "string") || data.filters[key] !== filters[key]) ||
		!validCursor(data.nextCursor) ||
		(data.nextCursor !== null && (!logs.length || cursors.includes(data.nextCursor)))) {
		throw new Error("Unconfirmed audit page");
	}
	return { logs, nextCursor: data.nextCursor };
}
